import React from "react";
import { AlertTriangle, Home, RotateCcw } from "lucide-react";

export class RouteErrorBoundaryCore extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Route render failed", error, info);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  handleRetry = () => {
    this.setState({ error: null });
  };

  handleHome = () => {
    this.setState({ error: null });
    this.props.onHome();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main
        data-testid="route-error-boundary"
        className="min-h-screen bg-[#030712] text-white flex items-center justify-center px-6 py-24"
      >
        <div
          role="alert"
          className="w-full max-w-xl rounded-sm border border-[#EF4444]/25 bg-[#0b1220] p-8 md:p-10 shadow-2xl"
        >
          <div className="inline-flex w-11 h-11 items-center justify-center rounded-sm bg-[#EF4444]/10 border border-[#EF4444]/25 text-[#F87171]">
            <AlertTriangle size={20} />
          </div>
          <h1 className="mt-6 font-display text-2xl md:text-3xl font-extrabold tracking-tight text-white">
            Diese Seite konnte nicht geladen werden.
          </h1>
          <p className="mt-4 text-sm md:text-base text-gray-400 leading-relaxed">
            Die restliche Anwendung bleibt verfügbar. Versuchen Sie es erneut
            oder kehren Sie zur Startseite zurück.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              type="button"
              onClick={this.handleRetry}
              data-testid="route-error-retry"
              className="inline-flex items-center justify-center gap-2 bg-[#0052FF] hover:bg-[#2563EB] text-white text-sm font-medium px-5 py-3 rounded-sm transition-colors"
            >
              <RotateCcw size={15} /> Erneut versuchen
            </button>
            <button
              type="button"
              onClick={this.handleHome}
              data-testid="route-error-home"
              className="inline-flex items-center justify-center gap-2 border border-white/15 hover:border-white/40 hover:bg-white/5 text-white text-sm font-medium px-5 py-3 rounded-sm transition-colors"
            >
              <Home size={15} /> Zur Startseite
            </button>
          </div>
        </div>
      </main>
    );
  }
}
